"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSuggestionKinds = void 0;
/**
 * Given statement positions, returns list of suggestion kinds that apply to those positions.
 */
function getSuggestionKinds(statementPosition, suggestionsKindRegistry) {
    let result = [];
    for (let i = 0; i < statementPosition.length; i++) {
        const exists = suggestionsKindRegistry.getIfExists(statementPosition[i]);
        if (exists) {
            result = result.concat(exists.kind);
        }
    }
    return result;
}
exports.getSuggestionKinds = getSuggestionKinds;
//# sourceMappingURL=getSuggestionKind.js.map